export enum WrapType {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  NOT_APPLICABLE,
  WRAP,
  UNWRAP,
}
